import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ShareModal = ({ event, isOpen, onClose }) => {
  if (!isOpen) return null;

  const eventUrl = window.location?.href;
  const shareText = `Check out ${event?.name} on ${new Date(event.date)?.toLocaleDateString()}!`;

  const shareOptions = [
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: 'bg-blue-600',
      action: () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`, '_blank');
      }
    },
    {
      name: 'Twitter',
      icon: 'Twitter',
      color: 'bg-sky-500',
      action: () => {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(eventUrl)}`, '_blank');
      }
    },
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: 'bg-blue-700',
      action: () => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(eventUrl)}`, '_blank');
      }
    },
    {
      name: 'WhatsApp',
      icon: 'MessageCircle',
      color: 'bg-green-600',
      action: () => {
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + eventUrl)}`, '_blank');
      }
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard?.writeText(eventUrl);
      // You could add a toast notification here
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4">
      <div className="bg-card rounded-lg shadow-elevation-4 w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-foreground">Share Event</h2>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground"
          />
        </div>
        
        <div className="p-6">
          <div className="mb-6">
            <h3 className="font-medium text-foreground mb-2">{event?.name}</h3>
            <p className="text-sm text-muted-foreground">
              {new Date(event.date)?.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })} at {event?.venue?.name}
            </p>
          </div>
          
          {/* Social Share Options */}
          <div className="grid grid-cols-2 gap-3 mb-6">
            {shareOptions?.map((option) => (
              <Button
                key={option?.name}
                variant="outline"
                onClick={option?.action}
                className="flex items-center justify-center gap-2 h-12"
              >
                <div className={`w-6 h-6 ${option?.color} rounded flex items-center justify-center`}>
                  <Icon name={option?.icon} size={14} color="white" />
                </div>
                <span>{option?.name}</span>
              </Button>
            ))}
          </div>
          
          {/* Copy Link */}
          <div className="space-y-3">
            <label className="text-sm font-medium text-foreground">Event Link</label>
            <div className="flex gap-2">
              <div className="flex-1 px-3 py-2 bg-muted rounded-md text-sm text-muted-foreground truncate">
                {eventUrl}
              </div>
              <Button
                variant="outline"
                size="sm"
                iconName="Copy"
                onClick={copyToClipboard}
              >
                Copy
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;